import { Alert, Button } from '@ui/themed';
import { t } from 'i18next';
import { findParentByVariantSku } from '../../products/product-search-rows';
import type { Product } from '../../products/types/product';
import { I18N_COMPONENTS } from '../constants';

export function UnusedSkuPrompt({
  term,
  results,
  onCreate,
}: {
  term: string;
  results: Product[] | undefined;
  onCreate: (sku: string) => void;
}) {
  const trimmed = term.trim();

  if (!trimmed || results === undefined || findParentByVariantSku(results, trimmed)) {
    return null;
  }

  return (
    <Alert variant="info" headingLevel="h2">
      <div className="flex w-full flex-col items-start gap-2">
        <span>{t(`${I18N_COMPONENTS}.unused_sku.message`, { sku: trimmed })}</span>
        <Button variant="secondary" onClick={() => onCreate(trimmed)}>
          {t(`${I18N_COMPONENTS}.unused_sku.action`, { sku: trimmed })}
        </Button>
      </div>
    </Alert>
  );
}
